import { createSlice } from "@reduxjs/toolkit";
import { getImpersonation } from "../utils/impersonation";

export const roleSlice = createSlice({
  name: "role",
  initialState: {
    roles: [],
  },
  reducers: {
    // Merges, so seeding just `roles` (NavListAuth on every route change)
    // keeps the `grantedPaths` the live session poll stored.
    update: (state, action) => {
      state.role = { ...(state.role || {}), ...action.payload };
    },
    destroy: (state) => {
      state.role = null;
    },
  },
});

export const { update, destroy } = roleSlice.actions;

// During an admin preview the previewed user's roles are the single source
// of truth, regardless of what the live session poll writes here.
export const selectRoles = (state) => {
  const impersonation = getImpersonation();
  if (impersonation) {
    return {
      roles: impersonation.user?.roles || [],
      grantedPaths: impersonation.user?.grantedPaths || [],
    };
  }
  return state.role.role;
};

export default roleSlice.reducer;
